// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__2jX4_","gray":"Logo_gray__22Wu7"};